module.exports = __webpack_public_path__ + "img/message-oto@2x.05d77dd1.png";